// extracted by mini-css-extract-plugin
export default {"preferencesForm":"tAIsbvan8M0X59wjwU8U"};